import { createAction } from 'deox';

import { ResponseError } from 'modules/errors';

import { GetArtworksQueryParams, GetArtworksResponse, ArtworkOrdering } from 'types';

export const getArtworks = {
  request: createAction('artworks/GET_ARTWORKS', (resolve) => (payload: GetArtworksQueryParams) =>
    resolve(payload),
  ),
  success: createAction(
    'artworks/GET_ARTWORKS_SUCCESS',
    (resolve) => (companyId: number, response: GetArtworksResponse) =>
      resolve({ companyId, response }),
  ),
  fail: createAction('artworks/GET_ARTWORKS_FAIL', (resolve) => (error: ResponseError) =>
    resolve(error),
  ),
};

export const sortArtworks = {
  request: createAction('artworks/SORT_ARTWORKS', (resolve) => (payload: GetArtworksQueryParams) =>
    resolve(payload),
  ),
  success: createAction(
    'artworks/SORT_ARTWORKS_SUCCESS',
    (resolve) => (companyId: number, ordering: ArtworkOrdering, response: GetArtworksResponse) =>
      resolve({ companyId, ordering, response }),
  ),
  fail: createAction('artworks/SORT_ARTWORKS_FAIL', (resolve) => (error: ResponseError) =>
    resolve(error),
  ),
};

export const searchArtwork = {
  request: createAction('artworks/SEARCH_ARTWORK', (resolve) => (payload: GetArtworksQueryParams) =>
    resolve(payload),
  ),
  success: createAction(
    'artworks/SEARCH_ARTWORK_SUCCESS',
    (resolve) => (companyId: number, search: string, response: GetArtworksResponse) =>
      resolve({ companyId, search, response }),
  ),
  fail: createAction('artworks/SEARCH_ARTWORK_FAIL', (resolve) => (error: ResponseError) =>
    resolve(error),
  ),
};

export const resetArtworksFilters = createAction(
  'artworks/RESET_ARTWORKS_FILTERS',
  (resolve) => (companyId: number) => resolve(companyId),
);
